(ns minorodata.connections.sources.hgem
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "hgem"
   :enabled      true
   :name         "HGEM"
   :description  "Measure what matters: Mystery Guests, Customer Feedback, Review Streams, Product Ratings, and much more"
   :image-source "hgem-logo.svg"
   :tags         ["data-import"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [name description api-key oauth-client-id oauth-client-secret]} data]
        {:source-type "hgem"
         :name        name
         :description description

         :source
         {:credentials         {:type                   "token"
                                :api-key                api-key
                                :oauth-client-id        oauth-client-id
                                :oauth-client-secret    oauth-client-secret}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge
         (select-keys credentials [:api-key :oauth-client-id :oauth-client-secret])
         {:name              name
          :description       description})))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id :hgem-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "HGEM API Key"
              :required   true
              :name       :api-key
              :type       :password
              :value      ""}
             {:block-type :input
              :label      "OAuth Client ID"
              :required   true
              :name       :oauth-client-id
              :value      ""}
             {:block-type :input
              :label      "OAuth Client Secret"
              :required   true
              :name       :oauth-client-secret
              :type       :password
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action destination-table report hgem-client-id]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:report            report
                    :hgem-client-id    hgem-client-id
                    :destination-table destination-table
                    :action            action}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:report :hgem-client-id :action :destination-table])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status}))))

    :validate (constantly nil)

    :id :hgem-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :input
              :label      "HGEM Client ID"
              :required   true
              :name       :hgem-client-id
              :value      ""}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Visits Plus"      :value "visits-plus"}]
              :required   true
              :value      "visits-plus"}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
